import Component from '../abstracts/Component';
import Masonry from 'masonry-layout';
import {SmoothScroll} from '../utils/SmoothScroll';

export default class HighlightsComponent extends Component {

  get SELECTORS() {
    return {
      Highlights: '.c-highlights',
      Container: '.highlights-content',
      Card: ".highlights-card",
      Filter: '.js-highlights-filter',
      FilterCounter: '.js-highlights-filter-counter',
      ResetFilters: '.js-highlights-filter-reset',
      AlertMsg: '.highlights-filters-alert'
    };
  }

  get CLASSES() {
    return {
      dNone: 'd-sm-none'
    }
  }

  constructor() {
    super();
    this.main = document.querySelectorAll(this.SELECTORS.Highlights);
    this.container = document.querySelector(this.SELECTORS.Container);
    this.cards = document.querySelectorAll(this.SELECTORS.Card);
    this.filter = document.querySelectorAll(this.SELECTORS.Filter);
    this.resetFilters = document.querySelector(this.SELECTORS.ResetFilters);
    this.alert = document.querySelector(this.SELECTORS.AlertMsg);
    this.gridElements = [];
  }


  importLibrary() {
    const container = document.querySelector(this.SELECTORS.Container);
    const msnryOpts = {
      columnWidth: '.card-sizer',
      horizontalOrder: false,
      percentPosition: true
    };

    if (document.body.classList.contains('editmode')) msnryOpts['itemSelector'] = '.highlights-card';

    this.msnry = new Masonry(this.SELECTORS.Container, msnryOpts);

    if (!document.body.classList.contains('editmode')) {
      this.gridElements.forEach(el => {
        el.classList.remove(this.CLASSES.dNone);
        container.appendChild(el);
        this.msnry.appended(el);
        this.msnry.layout();
      });
    }
  }


  onFiltering() {
    let counter = 0;

    this.$on('change.highlights', ({event}) => {
      let self = this;
      const el = event.currentTarget;
      this.applyFilters(el);
      self.resetFilters.checked = false;

      if (el.checked == true) {
        counter++;
      } else {
        counter--;
      }

      if (counter == '0') {
        self.resetFilters.checked = true;
      }

      self.filterCounter(counter);
      if (this.msnry) this.msnry.layout();
    }, this.SELECTORS.Filter);


    this.$on('change.highlightsReset', ({event}) => {
      let self = this;
      const el = event.currentTarget;

      self.filter.forEach((filter) => {
        filter.checked = false;
      });

      this.applyFilters(el);

      counter = 0;
      self.filterCounter(counter);

      if (this.msnry) this.msnry.layout();

    }, this.SELECTORS.ResetFilters);
  }


  filterCounter(counter) {
    const el = document.querySelector(this.SELECTORS.FilterCounter);
    const text = document.createTextNode(counter);
    el.classList.add('is-visible');
    el.innerHTML = text.data;

    if (text.data === '0') {
      el.classList.remove('is-visible');
    }
  }


  applyFilters(el) {
    const selectedFilter = el.value;
    const cards = this.cards
    let card;

    SmoothScroll(window, 0, 0, 'smooth');
    const checkedFilters = $('.js-highlights-filter:checked');

    cards.forEach((card, i) => {
      const string = card.dataset.tags;
      let shouldbechecked = false;

      if(checkedFilters.length > 0){
        checkedFilters.each(function () {
          const substring = $(this).val();
          const filtered = string.includes(substring);
          if(filtered){
            shouldbechecked = true;
          }
        })
      }else {
        shouldbechecked = true;
      }


      if (!shouldbechecked) {
        card.classList.add('is-filtered');
      } else {
        card.classList.remove('is-filtered');
      }

    });

    if (this.$matchMedia(null, 'md')) {
      this.msnry.layout();
    }

    this.onResults();
  }


  onResults() {
    let available = document.querySelectorAll(".highlights-card").length
    let filtered = document.querySelectorAll(".is-filtered").length;

    if (available == filtered) {
      this.alert.classList.add('is-visible');
    } else {
      this.alert.classList.remove('is-visible');
    }
  }


  render() {

    if (this.$matchMedia(null, 'sm')) {
      if (!document.body.classList.contains('editmode')) {
        const gridElements = document.querySelectorAll('.highlights-card');
        this.gridElements = gridElements;
        gridElements.forEach(el => {
          el.parentNode.removeChild(el);
        });
      }
      this.importLibrary();
    }

    if (this.$matchMedia('sm', null)) {
      window.addEventListener('scroll', (e) => {
        if ((document.querySelector('.footer-main').getBoundingClientRect()).top >= window.innerHeight) {
          $('.js-highlight-filters').addClass('is-shown');
        } else {
          $('.js-highlight-filters').removeClass('is-shown');
        }
      }, true);
    }

    this.onFiltering();
  }
}






